export const excelExport = (url, fileName) => {
    const elem = window.document.createElement('a');
    elem.href = url;
    elem.download = fileName;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
};
